import { render, staticRenderFns } from "./InputWithBtn.vue?vue&type=template&id=1380fa6d&scoped=true&"
import script from "./InputWithBtn.vue?vue&type=script&lang=ts&"
export * from "./InputWithBtn.vue?vue&type=script&lang=ts&"
import style0 from "./InputWithBtn.vue?vue&type=style&index=0&id=1380fa6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380fa6d",
  null
  
)

export default component.exports